import { isEmpty } from '.';
import Cookies from 'js-cookie';
let trackIdPrefix = process.env.VUE_APP_SA_EVENT_ID_PREFIX;
let trackNamePrefix = process.env.VUE_APP_SA_EVENT_NAME_PREFIX;
const openid = Cookies.get('openid') || '';
const commonTrack = (enventName, trackId, trackName, options) => {
    let params = Object.assign({}, options, {
        tgt_event_id: `${trackId}`,
        // tgt_event_id: `${trackIdPrefix}${trackId}`,
        // tgt_name: `${trackNamePrefix}${trackName}`
        tgt_name: `${trackName}`
    });
    params['url'] = isEmpty(params['url']) ? window.location.href : params['url'];
    params['target_url'] = isEmpty(params['target_url'])
        ? window.location.href
        : params['target_url'];

    window.sa && trackId && window.sa.track(enventName, params);
};

/**
 * h5点击元素
 * @param {*} trackId
 * @param {*} trackName
 * @param {*} options
 */
export const doTrackH5Clk = (trackName, options) => {
    options = Object.assign(
        {},
        {
            openid,
            tgt_type: 'button', // 元素类型 字符串 否 元素类型
            target_url: '', // 元素链接地址 字符串 是 元素链接地址
            url: '', // 页面地址 字符串 是 页面地址
            position: '', // 元素位置 字符串 否
            value_type: '', // value类型 字符串 否 value类型，类型包含：[idnumber,qq,weixinid ,weiboid,email],
            clk_value: '点击value' // 点击value 字符串 否 点击value
        },
        options
    );
    commonTrack('h5_clk', 'h5_ACT_button', trackName, options);
};
export const doTrackH5ElementPageview = (trackName, options) => {
    options = Object.assign(
        {},
        {
            openid,
            tgt_type: '', // 元素类型 字符串 否 元素类型，如box
            url: '', // 页面地址 字符串 是 页面地址
            element_value: '', // 元素内容 字符串 否
            position: '', // 元素位置 字符串 否
            extra: '' // 其他信息 字符串 否 [比如发生错误时当前的输入信息]
        },
        options
    );
    commonTrack('pageview', '$pageview', trackName, options);
};
/**
 * h5输入（填过内容并且失焦）
 * @param {*} trackId
 * @param {*} trackName
 * @param {*} options
 */
export const doTrackH5Input = (trackName, options) => {
    options = Object.assign(
        {},
        {
            input_value: '',
            openid,
            tgt_type: '', // 元素类型 字符串 否 元素类型
            url: '', // 页面地址 字符串 是 页面地址
            position: '', // 元素位置 字符串 否 暂时为空
            cost_time_ms: '' // 输入耗时 数值 否 输入信息所用时间，单位为ms
        },
        options
    );
    commonTrack('h5_input', 'h5_ACT_input', trackName, options);
};
/**
 * 元素曝光
 * @param {*} trackId
 * @param {*} trackName
 * @param {*} options
 */
export const doTrackH5ElementImp = (trackName, options) => {
    options = Object.assign(
        {},
        {
            openid,
            tgt_type: '', // 元素类型 字符串 否 元素类型，如box
            url: '', // 页面地址 字符串 是 页面地址
            element_value: '', // 元素内容 字符串 否
            position: '', // 元素位置 字符串 否
            extra: '' // 其他信息 字符串 否 [比如发生错误时当前的输入信息]
        },
        options
    );
    commonTrack('h5_element_imp', 'h5_ACT_imp', trackName, options);
};
/**
 * 元素曝光2现金提额度埋点需求
 * @param {*} trackId
 * @param {*} trackName
 * @param {*} options
 */
 export const doTrackH5ElementImp2 = (trackName, options) => {
    options = Object.assign(
        {},
        {
            openid,
            tgt_type: '', // 元素类型 字符串 否 元素类型，如box
            url: '', // 页面地址 字符串 是 页面地址
            element_value: '', // 元素内容 字符串 否
            position: '', // 元素位置 字符串 否
            extra: '' // 其他信息 字符串 否 [比如发生错误时当前的输入信息]
        },
        options
    );
    commonTrack('h5_element_imp', options.tgt_event_id ? `${options.tgt_event_id}` : 'h5_ACT_imp', trackName, options);
};

export const doTrackH5BannerClk = (trackName, options) => {
    options = Object.assign(
        {},
        {
            openid,
            banner: `${trackId}`, // Banner位 字符串 是 Banner位
            banner_name: `${trackName}`, // Banner名称 字符串 是 Banner位中文名
            target_url: '', // 目标地址 字符串 是 目标地址
            url: '' // 页面地址 字符串 是 页面地址
        },
        options
    );
    commonTrack('h5_banner_clk', 'h5_ACT_button', trackName, options);
};

export const doTrackH5BannerImp = (trackName, options) => {
    options = Object.assign(
        {},
        {
            openid,
            banner: `${trackId}`, // Banner位 字符串 是 Banner位
            banner_name: `${trackName}`, // Banner名称 字符串 是 Banner位中文名
            target_url: '', // 目标地址 字符串 是 目标地址
            url: '' // 页面地址 字符串 是 页面地址
        },
        options
    );
    commonTrack('h5_banner_imp', 'h5_ACT_button', trackName, options);
};

export const doTrackH5Clk2 = (trackName, options) => {
    options = Object.assign(
        {},
        {
            openid,
            tgt_type: '', // 元素类型 字符串 否 元素类型，如box
            url: '', // 页面地址 字符串 是 页面地址
            element_value: '', // 元素内容 字符串 否
            position: '', // 元素位置 字符串 否
            extra: '' // 其他信息 字符串 否 [比如发生错误时当前的输入信息]
        },
        options
    );
    commonTrack('h5_clk', options.tgt_event_id ? `${options.tgt_event_id}` : 'h5_ACT_button', trackName, options);
};